export default function FindingDirective() {
  return {
    template: require('./finding.html'),
    scope: {
      auditId: '=',
      findingCategoryId: '=',
      finding: '=',
      auditIsActive: '=',
      deleteCallback: '&',
    },
    controller: 'FindingController',
    controllerAs: 'findingVM',
    bindToController: true,
    replace: true
  };
}
